import React, { useRef, useState, useEffect } from "react";
import "./index.css";
import Swiper from "swiper/js/swiper.min.js";
import "swiper/css/swiper.min.css";
import ArticleDetail from "../../components/articleDetail";
import { getPosterOrArticle, getTab, getArticle } from "../../services/articleList";
import {ColumnIdArticle} from "../../services/request";
import moment from "moment";
const pageSizeDefault = 20;

const body = document.body.getBoundingClientRect();
let mySwpier = null;
export default function ArticleList() {
  const $tab = useRef();
  const $allLayout = useRef();
  const $listLayout = useRef();
  const [artList, setArtList] = useState([]);
  const [tabFlag, setTabFlag] = useState(0);
  const [tabList, setTabList] = useState([]);
  const [listContentH, setListContentH] = useState('100%');
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [nextLoadingFlag, setNextLoadingFlag] = useState(false);
  const [noData, seNoData] = useState(false);
  const [detailFlag, setDetailFlag] = useState(false);
  const [articleUrl, setArticleUrl] = useState("");
  const loading = useRef(false);
  const hasNextPage = useRef(true);
  const tabFlagRef = useRef(0);
  const artListRef = useRef([]);
  const [imgList, setImgList] = useState([]);
  const imgListRef = useRef([]);
  const pageNumRef = useRef(1);
  const hasNextRef = useRef(true);
  const [isFixed, setIsFixed] = useState(false)

  useEffect(() => {
    getArticleInit();
    getTabName(true);
    const layout = document.querySelector(".App-content");
    layout.addEventListener("scroll", calH);
    return () => {
      layout.removeEventListener("scroll", calH);
    };
  }, []);
  const calH = () => {
    const query = document.querySelector("#articleLayout");
    const layout = query.getBoundingClientRect();
    if (-layout.top + body.height > layout.height - 100) {
      getArticleById(tabFlagRef.current, pageNumRef.current + 1);
    }
    if ($listLayout.current.getBoundingClientRect().top < 0){
      setIsFixed(true);
    }else {
      setIsFixed(false);
    }
  };

  //开局获取直播稿件
  const getArticleInit = async () => {
    const Index = localStorage.getItem("articleListIndex");
    console.log("articleListIndex", Index);
    // if (phone === 2 && Index) {
    // if (Index) {
    //   const pn = Math.ceil(Index + 1 / pageSizeDefault);
    //   console.log("pn", pn);
    //   for (let i = 1; i <= pn; i++) {
    //     await getNextPoster(i);
    //   }
    //   mySwpier = new Swiper(".live-studio", {
    //     slidesPerView: 3,
    //     initialSlide: Index,
    //     spaceBetween:20,
    //     slidesOffsetAfter: document.body.clientWidth * 0.067,
    //     freeMode : true,
    //     freeModeMinimumVelocity : 0.2,
    //     freeModeMomentumRatio : 0.6,
    //     on: {
    //       slideChangeTransitionEnd: function () {
    //         if (this.activeIndex >= imgListRef?.current?.length - 4) {
    //           getNextPoster(pageNumRef.current + 1);
    //         }
    //       },
    //     },
    //   });
    // } else {
    //   getPosterInit();
    // }

    getPosterInit();
  };

  const getPosterInit = async () => {
    try {
      const res = await getArticle({
        columnId: 31811,
        pageNum: 1,
        pageSize: pageSizeDefault,
        service: 0,
        nfhSubCount: 0,
      });
      if (res.data?.code === 200) {
        setImgList(res.data?.data?.list || []);
        imgListRef.current = res.data?.data?.list || [];
        hasNextRef.current = res.data?.data?.hasNextPage;
        mySwpier = new Swiper(".live-studio", {
          slidesPerView: 3,
          initialSlide: 0,
          spaceBetween:20,
          slidesOffsetAfter: document.body.clientWidth * 0.099,
          freeMode : true,
          freeModeMinimumVelocity : 0.2,
          freeModeMomentumRatio : 0.6,
          on: {
            slideChangeTransitionEnd: function () {
              if (this.activeIndex >= imgListRef?.current?.length - 4) {
                getNextPoster(pageNumRef.current + 1);
              }
            },
          },
        });
      }
    } catch (e) {
      console.error(e);
    }
  };
  //获取下一页直播稿件
  const getNextPoster = async (pageNum) => {
    if (!hasNextRef.current) return;
    try {
      const res = await getArticle({
        columnId: ColumnIdArticle,
        pageNum,
        pageSize: pageSizeDefault,
        service: 0,
        nfhSubCount: 0,
      });
      if (res.data?.code === 200) {
        pageNumRef.current = pageNum;
        hasNextRef.current = res.data?.data?.hasNextPage;
        const newList = [...imgListRef.current, ...res.data?.data?.list];
        setImgList(newList);
        imgListRef.current = newList;
        mySwpier && mySwpier.update(true);
      }
    } catch (e) {
      console.error(e);
    }
  };

  // 获取tab的name
  const getTabName = async () => {
    try {
      const res = await getTab({
        parentColumnId: ColumnIdArticle,
      });
      setTabList(res.data?.columns?.filter(item=>item.columnId!=31811) || []);
      const columnId = localStorage.getItem("articleTab");
      // if (phone === 2 && columnId) {
      if (columnId) {
        changeTab(Number(columnId), true);
      } else {
        res.data?.columns?.length &&
          changeTab(res.data?.columns.filter(item=>item.columnId!=31811)[0].columnId, true);
      }
    } catch (e) {
      console.error(e);
    }
  };
  const changeTab = async (flag, init = false) => {
    if (loading.current) return;
    hasNextPage.current = true;
    seNoData(false);
    setTabFlag(flag);
    tabFlagRef.current = flag;
    setArtList([]);
    artListRef.current = [];
    // if (phone === 2 && init && localStorage.getItem("articlePN")) {
    if (init && localStorage.getItem("articlePN")) {
      const pn = localStorage.getItem("articlePN");
      for (let i = 1; i <= pn; i++) {
        if (i == pn) {
          await getArticleById(flag, i, true);
          return;
        }
        await getArticleById(flag, i);
      }
      getArticleById(flag, 1);
    } else {
      getArticleById(flag, 1);
    }
  };
  // 获取子栏目list
  const getArticleById = async (columnId, pageNum = 1, init = false) => {
    if (loading.current || !hasNextPage.current) return;
    loading.current = true;
    setLoadingFlag(true);
    pageNum > 1 && setNextLoadingFlag(true);
    let tabTop = $tab.current.getBoundingClientRect().top;
    try {
      const res = await getPosterOrArticle({
        columnId,
        pageNum,
        pageSize: 20,
        service: 0,
        nfhSubCount: 0,
      });
      if (res.data?.code === 200) {
        loading.current = false;
        setLoadingFlag(false);
        setNextLoadingFlag(false);
        pageNumRef.current = pageNum;
        if (pageNum === 1) {
          setArtList(res.data?.data?.list || []);
          artListRef.current = res.data?.data?.list || [];
          res.data?.data?.list &&
            !res.data?.data?.list.length &&
            seNoData(true);
          if (tabTop <= 0) {
            setTimeout(() => {
              $allLayout.current.scrollIntoView();
            }, 200);
          }
        } else {
          const newList = [...artListRef.current, ...res.data?.data?.list];
          artListRef.current = newList;
          setArtList(newList);
        }
        !res.data?.data?.hasNextPage && (hasNextPage.current = false);
        // if (init && phone === 2) {
        if (init) {
          setTimeout(() => {
            const layout = document.querySelector(".App-content");
            const st = localStorage.getItem("articleST");
            console.log("st", st);
            layout.scrollTop = st;
          }, 200);
        }
        setListContentH('100%')
      }
    } catch (e) {
      loading.current = false;
      setLoadingFlag(false);
      setNextLoadingFlag(false);
      console.error(e);
    }
  };

  const turnTo = (url) => {
    window.open(`${url}`)
    const layout = document.querySelector(".App-content");
    localStorage.setItem("articleST", layout.scrollTop);
    localStorage.setItem("articlePN", pageNumRef.current);
    localStorage.setItem("articleTab", tabFlagRef.current);
  };
  return (
    <div
      className="article-layout"
      id="articleLayout"
    // onTouchMove={(e) => {
    //   const layout = e.currentTarget.getBoundingClientRect()
    //   // console.log(-layout.top, body.height, layout.height)
    //   if (-layout.top + body.height > layout.height - 100) {
    //     getArticleById(tabFlag, pageNum + 1)
    //   }
    // }}
    >
      <div className="live-studio-layout">
        <h4></h4>
        <div className="swiper-container live-studio">
          <div className="swiper-wrapper">
            {imgList.map((item) => (
                <div className="swiper-slide" key={item.articleId} onClick={() => {
                  turnTo(item.shareUrl);
                  if (mySwpier?.progress == 1) {
                    localStorage.setItem(
                        "articleListIndex",
                        mySwpier?.activeIndex + 1
                    );
                  } else {
                    localStorage.setItem(
                        "articleListIndex",
                        mySwpier?.activeIndex
                    );
                  }
                  return;
                }}>
                  <img className="live-studio-photo" alt="" src={ item?.picMiddle || require("../../assets/pic_default.png")} />
                  <div className="live-studio-name">{item.title}</div>
                </div>
            ))}
          </div>
        </div>
      </div>
      <div className="utilities-content">
        <div className="utilities-imgs">
          <div className="utility-content" onClick={() => {
            window.open("https://static.nfapp.southcn.com/content/202111/11/c5928757.html");
            return;
          }}>
            <img src={require("../../assets/icon_1.png")} alt=""/>
          </div>
          <div className="utility-content" onClick={() => {
            window.open("https://static.nfapp.southcn.com/content/202111/16/c5943674.html");
            return;
          }}>
            <img src={require("../../assets/icon_2.png")} alt=""/>
          </div>
        </div>
      </div>
      <div ref={$allLayout} style={{position: 'relative'}}>
        <div className={`article-tab-layout ${isFixed ? 'article-tab-fixed' : 'article-tab-absolute'}`} ref={$tab}>
          {tabList.map((item,key) => (
            <div
              className={
                `article-tab-${key} ${tabFlag === item.columnId ? "article-tab active" : "article-tab"}`
              }
              key={item.columnId}
              onClick={() => {
                setListContentH((window.screen.height - $tab.current.offsetHeight) + 'px');
                changeTab(item.columnId);
              }}
            >
              {/* {item.columnName} */}
            </div>
          ))}
        </div>
        <div style={{height: listContentH}} className="list-content-top" ref={$listLayout}>
          {noData && <div className="list-loading">暂无数据</div>}
          {loadingFlag && <div className="list-loading">加载中...</div>}
          {artList.map((item) => (
            <div
              className="list-layout"
              onClick={() => {
                // const deviceid =
                //   window.localStorage.getItem("nfplus_deviceid") || "";
                // savePoint({
                //   dataType: "1000099",
                //   actionTime: Date.now(),
                //   refer: "",
                //   url: window.location.href,
                //   deviceid,
                //   origin: 8,
                //   action: 29,
                //   articleID: item.articleId,
                // });
                // if (phone === 2) {
                turnTo(item.shareUrl);
                return;
                // }
                // setArticleUrl(item.shareUrl);
                // setDetailFlag(true);
              }}
              key={item.articleId}
            >
              <div className="list-layout-l">
                <div className="list-layout-l-title">{item.title}</div>
                <span className="list-layout-l-time">
                  {moment(item.releaseTime).format("MM-DD HH:mm")}
                </span>
              </div>
              {item.picSmall ? (
                <img className="list-layout-r" src={item.picSmall} alt="" />
              ) : (
                  <img
                    className="list-layout-r"
                    src={require("../../assets/pic_default2.png")}
                    alt=""
                  />
                )}
            </div>
          ))}
          {nextLoadingFlag && <div className="list-loading">加载中...</div>}
        </div>
      </div>
      {detailFlag && (
        <ArticleDetail
          articleUrl={articleUrl}
          close={() => {
            setDetailFlag(false);
          }}
        ></ArticleDetail>
      )}
    </div>
  );
}
